const ROLE_TYPES = {
  ADMIN: 'Admin',
  TEACHER: 'Teacher',
  STUDENT: 'Student'
};

export default ROLE_TYPES;
